export enum Role {
  PS_ADMIN = 'ps:admin',
  PRUEFER = 'proof:inspector',
  DASHBOARD_CONTROLLER = 'dashboard-controller',
  GUTACHTER = 'gm:gutachter',
  MANDANT_SACHBEARBEITER = 'ps:mandant-sachbearbeiter',
}
